import React from 'react'
import ReactDOM from 'react-dom'
import { ConfigProvider } from 'hljd'

export const render = Component => {
  ReactDOM.render(
    <ConfigProvider
      getPopupContainer={triggerNode => {
        if (triggerNode) {
          return triggerNode.parentElement || document.body
        }

        return document.body
      }}
    >
      <Component />
    </ConfigProvider>,
    document.getElementById('root')
  )
}
